export enum EOpcaoExportacaoArquivo {
  CSV = 'csv',
  EXCEL = 'xls',
  PDF = 'pdf',
}

interface OpcaoExportacaoArquivoInfo {
  nome: string;
  indice: number;
  label: string;
  isHabilitado: boolean;
}

export const OpcaoExportacaoArquivoDetalhe: { [key in EOpcaoExportacaoArquivo]: OpcaoExportacaoArquivoInfo } = {
  [EOpcaoExportacaoArquivo.CSV]: {
    nome: 'CSV',
    indice: 0,
    label: 'Csv',
    isHabilitado: true,
  },
  [EOpcaoExportacaoArquivo.EXCEL]: {
    nome: 'EXCEL',
    indice: 2,
    label: 'Excel',
    isHabilitado: true,
  },
  [EOpcaoExportacaoArquivo.PDF]: {
    nome: 'PDF',
    indice: 2,
    label: 'Pdf',
    isHabilitado: false,
  },
};

export const getOpcaoExportacaoArquivoDefault = () => {
  return EOpcaoExportacaoArquivo.CSV;
};
